import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ContextMenuItem, ContextMenuSeparator } from '../../../../../../components';
import { SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/priceEventHistory';

type PriceEventHistoryProps = ReturnType<typeof mapDispatchToProps> & {
  /** Separador antes do item; quem monta o menu desliga quando não há item acima. */
  withSeparator?: boolean;
};

const PriceEventHistoryContextMenu = ({ openModal, withSeparator = true }: PriceEventHistoryProps) => {
  return (
    <>
      {withSeparator && <ContextMenuSeparator />}
      <ContextMenuItem onClick={openModal}>Resumo de alteração de preço</ContextMenuItem>
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openModal: () => dispatch(SET_IS_OPEN(true)),
});

export default connect(null, mapDispatchToProps)(PriceEventHistoryContextMenu);
